export default __webpack_public_path__ + "static/media/assessment_glide_5_2.9a6b7002.svg";